// Shared unlock token for all hidden pages (/lab, /drop, /describe).
// They authenticate against the same Mac password, so unlocking one unlocks all
// (within the same browser). One shared localStorage key, with migration from the
// old per-page keys so existing sessions don't get logged out.
//
// localStorage can throw when site storage is blocked — guard every access so the
// pages degrade to "no persistence" instead of crashing.

const TOKEN_KEY = 'hidden_token';
const LEGACY_KEYS = ['llm_token', 'files_token', 'describe_token'];

const ls = {
  get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
  remove(k) { try { localStorage.removeItem(k); } catch (e) {} },
};

export function getToken() {
  const t = ls.get(TOKEN_KEY);
  if (t) return t;
  for (const k of LEGACY_KEYS) {       // migrate a prior per-page unlock
    const v = ls.get(k);
    if (v) { ls.set(TOKEN_KEY, v); return v; }
  }
  return '';
}

export function setToken(t) {
  ls.set(TOKEN_KEY, t);
}

export function clearToken() {
  ls.remove(TOKEN_KEY);
  LEGACY_KEYS.forEach((k) => ls.remove(k));  // global lock: also drop legacy keys
}
